export interface IconProps {
  size?: keyof typeof iconSizes;
  title?: string;
}

// Note: for now, these value stay co-located to the icons.
// But with the global rework of size & spacing of UI, this should be moved
export const iconSizes = {
  "3xs": 4,
  xxs: 8,
  xs: 12,
  s: 16,
  m: 20,
  l: 24,
  xl: 32,
};
